var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgHeartEcg(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.77 6c3.73 0 6.085 2.54 6.085 6.515a8.022 8.022 0 01-.59 3.166l-.139.318h.453a.5.5 0 01.09.993l-.09.008-1.027-.001-.126.205-.284.37c-.294.372-.608.73-.942 1.072l-.34.338-.33.306-.433.414-.495.49-.517.492-.606.558-.898.81-1.342 1.19-2.698 2.34a.816.816 0 01-.526.21l-.061-.002-.032.006a.77.77 0 01-.423-.088l-.095-.058-.092-.07-2.698-2.342-1.342-1.189-.899-.81-.607-.56-.52-.494-.48-.476-.428-.41a13.97 13.97 0 01-1.326-1.363l-.304-.37-.306-.406L6.3 17h-.8a.5.5 0 01-.09-.991l.09-.008h.228A7.999 7.999 0 015 12.525C5.001 8.54 7.356 6 11.088 6c1.715.009 3.396.796 4.592 2.078l.185.207.063.076.064-.076c1.081-1.263 2.621-2.095 4.235-2.256l.286-.022.258-.007zm-.604 8.765l-.588 1.884a.5.5 0 01-.386.342l-.091.009h-1.29l-1.037 2.109c-.204.414-.793.347-.924-.062l-.02-.092-.515-3.834-.457 1.523a.5.5 0 01-.397.35l-.082.006h-1.22l-1.328 1.393a.5.5 0 01-.835-.18l-.02-.084-.484-2.957-.595 1.511a.5.5 0 01-.38.31L9.432 17H7.534c.358.447.744.87 1.163 1.27l.32.297.446.427.48.475.506.481.598.552.891.804 1.335 1.182 2.655 2.304 2.651-2.3 1.335-1.183.891-.804.596-.55.505-.479.493-.488.445-.426.33-.305c.318-.306.62-.627.903-.96l.243-.298H22.6l-1.03 1.752a.5.5 0 01-.908-.102l-.02-.09-.476-3.794zM20.773 7c-1.723.009-3.431.973-4.428 2.472a.5.5 0 01-.833 0c-.998-1.5-2.707-2.463-4.427-2.472-3.159 0-5.084 2.076-5.084 5.533a7.028 7.028 0 00.625 3.029l.133.275.099.162h2.233l1.137-2.883c.175-.442.792-.405.936.014l.023.09.613 3.756.783-.821a.5.5 0 01.281-.148l.081-.007h1.062l1.017-3.386c.146-.484.812-.462.954-.018l.02.095.604 4.5.45-.912a.5.5 0 01.355-.27l.093-.01h1.232l1.166-3.728c.15-.481.816-.453.953-.008l.02.095.58 4.622.433-.734a.5.5 0 01.344-.238l.087-.008 2.684-.001.074-.118.143-.294c.44-.957.658-2 .639-3.063C25.855 9.076 23.93 7 20.773 7z"
  }));
}

export default SvgHeartEcg;